import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { initSagas } from '../sagas';

import authReducer from '../reducers/auth.reducer';
import menuReducer from '../reducers/menu.reducer';
import busquedasReducer from '../reducers/busquedas.reducer';
import formReducer from '../reducers/form.reducer';
import fuentesAbiertasReducer from '../reducers/fuentesabiertas.reducer';
import grafosReducer from '../reducers/grafos.reducer';
import reportReducer from '../reducers/report.reducer';
import filtersReducer from '../reducers/filters.reducer';
import grafosBalisticaReducer from '../views/balistica/correlaciones/reducers/graph.reducer';

const initialState = {
    sidebarShow: true,
}

const changeState = (state = initialState, { type, ...rest }) => {
    switch (type) {
        case 'set':
            return { ...state, ...rest }
        default:
            return state
    }
}

const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];

const storeConfig = () => {

    const store = configureStore({
        reducer: {
            auth: authReducer,
            sidebar: changeState,
            menuNavigation: menuReducer,
            busquedas: busquedasReducer,
            forms: formReducer,
            fuentesAbiertas: fuentesAbiertasReducer,
            reportes: reportReducer,
            filters: filtersReducer,
            balistica: grafosBalisticaReducer
        },
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false
        }).concat(middleware)
    });

    initSagas(sagaMiddleware);

    return store;
};

export default storeConfig;